<script setup lang="ts">
import { usePopupMessage } from '../composable/usePopupMessage';
const { isDisplayMessage, displayedMessage, onGotMessage } = usePopupMessage();

const messageAttributes = computed(() => {
  return displayedMessage.value.attributes;
});

const messageData = computed(() => {
  return displayedMessage.value.message;
});
</script>

<template>
  <Toast v-if="isDisplayMessage" class="mb-2" v-bind="messageAttributes" @action="onGotMessage">
    <template #description>{{ messageData }}</template>
  </Toast>
</template>

<style scoped></style>
